// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

export const firebaseConfig = {
  apiKey: "AIzaSyAP_4Rru3j9VkOplBcdBt-FZdtngDhEmg8",
  authDomain: "survey-me-dev.firebaseapp.com",
  projectId: "survey-me-dev",
  storageBucket: "survey-me-dev.firebasestorage.app",
  messagingSenderId: "117048375116",
  appId: "1:117048375116:web:cdc7256fc5b0bac53281e9",
  measurementId: "G-P923NZGJJL"
};



// export const firebaseConfig = {
//   apiKey: "AIzaSyBciZHp0Qad_1lOZ3JWILnSjP853iaHvek",
//   authDomain: "survey-m3.firebaseapp.com",
//   projectId: "survey-m3",
//   storageBucket: "survey-m3.appspot.com",
//   messagingSenderId: "975281313744",
//   appId: "1:975281313744:web:ee56b5b2dfa9ffd92bcbd5",
//   measurementId: "G-GTB9LF6RSB"
// };
